import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

const ReferralOutboundPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound')
);

const CreateReferralWizard = loadable(
  () => import('@/pages/CRM/ReferralOutbound/CreateReferralWizard')
);

const PartnerPortalPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/PartnerPortal')
);

const ReferralManagementPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/ReferralManagement')
);

export enum CRMReferralOutboundRoutes {
  CRMReferralOutbound = '/crm/referral-outbound',
  CRMReferralOutboundSend = '/crm/referral-outbound/send',
  CRMReferralOutboundPartner = '/crm/referral-outbound/partner/:recipientFacilityId',
  CRMReferralOutboundManagement = '/crm/referral-outbound/:referral_id'
}

export const getCrmReferralOutboundRoutes = (): RouteObject[] => {
  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_REFERRAL_OUTBOUND)) {
    return [];
  }
  return [
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutbound,
      element: <ReferralOutboundPage />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundSend,
      element: <CreateReferralWizard />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundPartner,
      element: <PartnerPortalPage />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundManagement,
      element: <ReferralManagementPage />
    }
  ];
};
